import pagePermissions from '@/enums/pagePermissions';
import { PlanType } from '@/enums/planType';
import { PermissionMiddleware } from '@/router/Middleware/PermissionMiddleware';

const crmRoutes = [
  {
    path: '/crm/plans',
    name: 'crm-plans',
    component: () => import('../Pages/CRM/Plans/index.vue'),
    meta: {
      name: 'CRM - Планировки',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/plans-database',
    name: 'crm-plans-database',
    component: () => import('../Pages/CRM/PlansDatabase/index.vue'),
    meta: {
      name: 'CRM - База планировок',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/plans/:id',
    name: 'crm-plans-show',
    component: () => import('../Pages/CRM/Plans/id.vue'),
    meta: {
      name: 'CRM - Планировка',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/plans/3d/:id',
    name: 'crm-plans3d-show',
    component: () => import('../Pages/CRM/Plans/id-3d.vue'),
    meta: {
      name: 'Планировка 3D',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/work-schedule',
    name: 'crm-work-schedule',
    component: () => import('../Pages/CRM/WorkSchedule/index.vue'),
    meta: {
      name: 'CRM - График рабочего времени',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/work-schedule/employees/:id',
    name: 'crm-work-schedule-employee',
    component: () => import('../Pages/CRM/WorkSchedule/Employee.vue'),
    meta: {
      name: 'CRM - График сотрудника',
      permission: 'crm.work_schedule.view',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/payroll',
    name: 'crm-payroll',
    component: () => import('../Pages/CRM/Payroll/index.vue'),
    meta: {
      name: 'CRM - Мои начисления',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/payroll/employees',
    name: 'crm-payroll-employees',
    component: () => import('../Pages/CRM/Payroll/Employees.vue'),
    meta: {
      name: 'CRM - Начисления сотрудников',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/payroll/employees/:id',
    name: 'crm-payroll-employee',
    component: () => import('../Pages/CRM/Payroll/Employee.vue'),
    meta: {
      name: 'CRM - Начисления сотрудника',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/reviews',
    name: 'crm-reviews',
    component: () => import('../Pages/CRM/QualityReview/Reviews.vue'),
    meta: {
      name: 'CRM - Проверка качества',
      featureFlag: 'isQualityReviewPanelsVisible',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/review/:id',
    name: 'crm-review-show',
    component: () => import('../Pages/CRM/QualityReview/ReviewWorkspace.vue'),
    meta: {
      name: 'CRM - Рабочее место проверки',
      featureFlag: 'isQualityReviewPanelsVisible',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/ninja-board',
    name: 'crm-ninja-board',
    component: () => import('../Pages/CRM/QualityReview/NinjaBoard.vue'),
    meta: {
      name: 'CRM - Панель ниндзя',
      featureFlag: 'isQualityReviewPanelsVisible',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/fix/:id',
    name: 'crm-fix-show',
    component: () => import('../Pages/CRM/QualityReview/FixWorkspace.vue'),
    meta: {
      name: 'CRM - Режим исправления',
      featureFlag: 'isQualityReviewPanelsVisible',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/upload',
    name: 'crm-upload',
    component: () => import('../Pages/CRM/Upload/index.vue'),
    meta: {
      name: 'CRM - Загрузка планировки',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/search',
    name: 'crm-search',
    component: () => import('../Pages/CRM/Search/index.vue'),
    meta: {
      name: 'CRM - Поиск планировок',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/search/:crm_id?',
    name: 'crm-search-reference',
    component: () => import('../Pages/CRM/Search/index.vue'),
    meta: {
      name: 'CRM - Поиск планировок',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/my-plans',
    name: 'crm-my-plans',
    component: () => import('../Pages/CRM/MyPlans/index.vue'),
    meta: {
      name: 'CRM - Мои планировки',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/apartments',
    name: 'crm-apartments',
    component: () => import('../Pages/CRM/Apartments/index.vue'),
    meta: {
      name: 'CRM - Апартаменты',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/production-matrix',
    name: 'crm-production-matrix',
    component: () => import('../Pages/CRM/ProductionMatrix/index.vue'),
    meta: {
      name: 'CRM - Матрица производства',
      anyPermission: 'crm.work_schedule.view',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/production-matrix/distribution',
    name: 'crm-production-matrix-distribution',
    component: () => import('../Pages/CRM/ProductionMatrix/index.vue'),
    meta: {
      name: 'CRM - Распределение сотрудников',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/production-matrix/schedule',
    name: 'crm-production-matrix-schedule',
    component: () => import('../Pages/CRM/ProductionMatrix/index.vue'),
    meta: {
      name: 'CRM - График сотрудников',
      permission: 'crm.work_schedule.view',
    },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/apartments/:id/render_styles/:styleId/revisions/new',
    name: 'crm-apartment-style-revision-create',
    component: () => import('../Pages/CRM/Apartments/ApartmentObjectRevisionCreate.vue'),
    meta: { name: 'Новая редакция рекомендуемых объектов' },
    beforeEnter: PermissionMiddleware,
  },
  {
    path: '/crm/apartments/:id',
    name: 'crm-apartments-id',
    component: () => import('../Pages/CRM/Apartments/id.vue'),
    meta: {
      name: 'CRM - Апартаменты',
    },
    beforeEnter: PermissionMiddleware,
  },
  // {
  //   path: '/crm/statistic/ninja',
  //   name: 'crm-statistic-ninja',
  //   component: () => import('../Pages/CRM/Statistic/ninja.vue'),
  //   meta: {
  //     name: 'CRM - Статистика по ниндзя',
  //
  //   },
  // },
  {
    path: '/crm/apartments/:id/plans/:planId',
    name: 'crm-apartments-plans-show',
    component: () => import('../Pages/CRM/Apartments/plans.vue'),
    props: {
      type: PlanType.Type2d,
    },
    meta: {
      name: 'CRM - Планировки апартамента',
    },
  },
  {
    path: '/crm/apartments/:id/plans/3d/:planId',
    name: 'crm-apartments-plans-3d-show',
    component: () => import('../Pages/CRM/Apartments/plans.vue'),
    props: {
      type: PlanType.Type3d,
    },
    meta: {
      name: 'CRM - Планировки апартамента',
    },
  },
  {
    path: '/crm/statistic/particularNinja',
    name: 'crm-statistic-particular-ninja',
    component: () => import('../Pages/CRM/ParticularNinjaStatistic/index.vue'),
    meta: {
      name: 'CRM - Статистика по отдельным ниндзя',
    },
  },
  {
    path: '/crm/plans/cutting',
    name: 'crm-cutting-plans',
    component: () => import('../Pages/CRM/CuttingPlans/index.vue'),
    meta: {
      name: 'CRM - Нарезка планировок',
    },
  },
  {
    path: '/crm/plans/cutting/:id',
    name: 'crm-cutting-plans-show',
    component: () => import('../Pages/CRM/CuttingPlans/id.vue'),
    meta: {
      name: 'CRM - Нарезка планировок',
    },
  },
  {
    path: '/crm/customers',
    name: 'crm-customers',
    component: () => import('../Pages/CRM/Customers/index.vue'),
    meta: {
      name: 'CRM - Заказчики',
    },
    beforeEnter: PermissionMiddleware,
  },

];

crmRoutes.forEach((route) => {
  if (pagePermissions[route.name]) route.meta.permission = pagePermissions[route.name];
});

export { crmRoutes };
